import { c as _c } from "react/compiler-runtime";
import { ClassValue } from "clsx";
import cn from "@/utils/cn";
export default function Icon(t0) {
  const $ = _c(10);
  let Component;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      component: Component,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = Component;
    $[2] = className;
    $[3] = props;
  } else {
    Component = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("size-[1.25em]", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== Component || $[7] !== props || $[8] !== t1) {
    t2 = <Component className={t1} {...props} />;
    $[6] = Component;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}